import { render, staticRenderFns } from "./ModalHistoricoCobranca.vue?vue&type=template&id=5aac1287&scoped=true"
import script from "./ModalHistoricoCobranca.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoCobranca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aac1287",
  null
  
)

export default component.exports